<template>
  <div>
    <div
      ref="content_inner"
      class="content text-pretty"
      data-test="text-content"
      :style="clamp_style"
      v-html="html_text"
    />
    <button
      v-if="is_overflowing"
      type="button"
      class="mt-1 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:underline"
      :aria-expanded="is_expanded"
      @click.stop="is_expanded = !is_expanded"
    >
      {{ $t(is_expanded ? 'editor_ziggu.actions.showLess' : 'editor_ziggu.actions.showMore') }}
      <FontAwesomeIcon
        :icon="['far', 'chevron-down']"
        class="transition-transform duration-200"
        :class="{ 'rotate-180': is_expanded }"
      />
    </button>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';

const props = defineProps({
  html_text: { type: String, required: true },
  lines: { type: Number, default: 4 },
});

const content_inner = ref(null);
const is_expanded = ref(false);
const is_overflowing = ref(false);

const clamp_style = computed(() => {
  if (is_expanded.value) return {};
  return {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: String(props.lines),
    overflow: 'hidden',
  };
});

onMounted(async () => {
  await nextTick();
  if (!content_inner.value) return;
  is_overflowing.value = content_inner.value.scrollHeight > content_inner.value.clientHeight + 1;
});
</script>
